// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"71100cb7","44":"1da6512c","257":"144ed385","381":"c0d24483","387":"009fb51b","446":"f8c5553e","453":"fd2f0c4a","587":"60e4d2c9","904":"df5717ac"}[chunkId] + ".chunk.js";
};